import Vue from 'vue'
import Vuex from 'vuex'

import {
  UPDATE_PLANS,
  REMOVE_PLAN,
  UPDATE_COMPARE_MODE,
  UPDATE_NOTICE_TEXT,
  UPDATE_COMPARING,
  UPDATE_LOADING_DATA,
} from './mutation-types'

Vue.use(Vuex)

/* Store state */
let state = {
    plans: [],
    compareMode: false,
    noticeText: '',
    comparing: false,
    loadingData: false,
}

/* Mutations */
export const mutations = {
  [UPDATE_PLANS] (state, payload) {
    state.plans = payload.value
  },

  [REMOVE_PLAN] (state, payload) {
    state.plans.splice(payload.index, 1)
  },

  [UPDATE_COMPARE_MODE] (state, payload) {
    state.compareMode = payload.value
  },

  [UPDATE_NOTICE_TEXT] (state, payload) {
    state.noticeText = payload.value
  },

  [UPDATE_COMPARING] (state, payload) {
    state.comparing = payload.value
  },

  [UPDATE_LOADING_DATA] (state, payload) {
    state.loadingData = payload.value
  },
}

/* Actions */
export const actions = {
  updatePlans ({ commit }, value) {
    commit({
      type: UPDATE_PLANS,
      value
    })
  },

  removePlan ({ commit }, index) {
    commit({
      type: REMOVE_PLAN,
      index
    })
  },

  updateCompareMode ({ commit }, value) {
    commit({
      type: UPDATE_COMPARE_MODE,
      value
    })
  },

  updateNoticeText ({ commit }, value) {
    commit({
      type: UPDATE_NOTICE_TEXT,
      value
    })
  },

  updateComparing ({ commit }, value) {
    commit({
      type: UPDATE_COMPARING,
      value
    })
  },

  loadingData ({ commit }, value) {
    commit({
      type: UPDATE_LOADING_DATA,
      value
    })
  },

  
}

export const getters = {}

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  state,
  mutations,
  actions,
  getters
})
